(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[607],{

/***/ 4197:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/endorsements",
      function () {
        return __webpack_require__(524);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PageTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function PageTitle(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        className: "text-3xl font-extrabold leading-9 tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl sm:leading-10 md:text-5xl md:leading-14",
        children: children
    });
}


/***/ }),

/***/ 9829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": function() { return /* binding */ TagSEO; },
/* harmony export */   "TQ": function() { return /* binding */ PageSEO; },
/* harmony export */   "Uy": function() { return /* binding */ BlogSEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _data_siteMetadata__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1576);
/* harmony import */ var _data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3__);




const CommonSEO = (param)=>{
    let { title , description , ogType , ogImage , twImage  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "follow, index"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl)).concat(router.asPath)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: ogType
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().title)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            typeof ogImage === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: ogImage
            }, ogImage) : ogImage.map((param)=>/*#__PURE__*/ {
                let { url  } = param;
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: url
                }, url);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().twitter)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: twImage
            })
        ]
    });
};
const PageSEO = (param)=>{
    let { title , description  } = param;
    const ogImageUrl = (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl) + (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().socialBanner);
    const twImageUrl = (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl) + (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().socialBanner);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommonSEO, {
        title: title,
        description: description,
        ogType: "website",
        ogImage: ogImageUrl,
        twImage: twImageUrl
    });
};
const TagSEO = (param)=>{
    let { title , description  } = param;
    const ogImageUrl = (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl) + (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().socialBanner);
    const twImageUrl = (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl) + (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().socialBanner);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommonSEO, {
                title: title,
                description: description,
                ogType: "website",
                ogImage: ogImageUrl,
                twImage: twImageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "alternate",
                    type: "application/rss+xml",
                    title: "".concat(description, " - RSS feed"),
                    href: "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl)).concat(router.asPath, "/feed.xml")
                })
            })
        ]
    });
};
const BlogSEO = (param)=>{
    let { title , summary , date , lastModified , url , images =[]  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const publishedAt = new Date(date).toISOString();
    const modifiedAt = new Date(lastModified || date).toISOString();
    let imagesArr = images.length === 0 ? [
        (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().socialBanner)
    ] : typeof images === "string" ? [
        images
    ] : images;
    const featuredImages = imagesArr.map((img)=>{
        return {
            "@type": "ImageObject",
            url: "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl)).concat(img)
        };
    });
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Article",
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": url
        },
        headline: title,
        image: featuredImages,
        datePublished: publishedAt,
        dateModified: modifiedAt,
        author: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().author),
        publisher: {
            "@type": "Organization",
            name: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().author),
            logo: {
                "@type": "ImageObject",
                url: "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl)).concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteLogo))
            }
        },
        description: summary
    };
    const twImageUrl = featuredImages[0].url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommonSEO, {
                title: title,
                description: summary,
                ogType: "article",
                ogImage: featuredImages,
                twImage: twImageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    date && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "article:published_time",
                        content: publishedAt
                    }),
                    lastModified && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "article:modified_time",
                        content: modifiedAt
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl)).concat(router.asPath)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(structuredData, null, 2)
                        }
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ EndorsementsPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/SEO.tsx
var SEO = __webpack_require__(9829);
// EXTERNAL MODULE: ./data/siteMetadata.js
var siteMetadata = __webpack_require__(1576);
var siteMetadata_default = /*#__PURE__*/__webpack_require__.n(siteMetadata);
// EXTERNAL MODULE: ./components/PageTitle.tsx
var PageTitle = __webpack_require__(2866);
// EXTERNAL MODULE: ./lib/fetcher.ts
var fetcher = __webpack_require__(6965);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var react = __webpack_require__(3299);
// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./components/ErrorMessage.tsx

function ErrorMessage(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "flex items-center text-sm font-bold text-danger-800 dark:text-danger-400 my-1 sm:my-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 20 20",
                fill: "currentColor",
                className: "mr-2 h-4 w-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
                    clipRule: "evenodd"
                })
            }),
            children
        ]
    });
}

;// CONCATENATED MODULE: ./components/SuccessMessage.tsx

function SuccessMessage(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "text-sm font-bold text-success-700 dark:text-success-400 my-1 sm:my-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 20 20",
                fill: "currentColor",
                className: "mr-2 h-4 w-4 inline-block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                    clipRule: "evenodd"
                })
            }),
            children
        ]
    });
}

;// CONCATENATED MODULE: ./components/LoadingSpinner.tsx

function LoadingSpinner() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "animate-spin h-4 w-4 text-gray-900 dark:text-gray-100",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Skills/plus-square-outline.svg
var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgPlusSquareOutline(props) {
  return /*#__PURE__*/node_modules_react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/node_modules_react.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/node_modules_react.createElement("g", {
    "data-name": "plus-square"
  }, /*#__PURE__*/node_modules_react.createElement("path", {
    d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H6a1 1 0 01-1-1V6a1 1 0 011-1h12a1 1 0 011 1z"
  }), /*#__PURE__*/node_modules_react.createElement("path", {
    d: "M15 11h-2V9a1 1 0 00-2 0v2H9a1 1 0 000 2h2v2a1 1 0 002 0v-2h2a1 1 0 000-2z"
  })))));
}

/* harmony default export */ var plus_square_outline = (SvgPlusSquareOutline);
;// CONCATENATED MODULE: ./components/Skills/checkmark-circle-outline.svg
var checkmark_circle_outline_g;

function checkmark_circle_outline_extends() { checkmark_circle_outline_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return checkmark_circle_outline_extends.apply(this, arguments); }



function SvgCheckmarkCircleOutline(props) {
  return /*#__PURE__*/node_modules_react.createElement("svg", checkmark_circle_outline_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), checkmark_circle_outline_g || (checkmark_circle_outline_g = /*#__PURE__*/node_modules_react.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/node_modules_react.createElement("g", {
    "data-name": "checkmark-circle"
  }, /*#__PURE__*/node_modules_react.createElement("path", {
    d: "M9.71 11.29a1 1 0 00-1.42 1.42l3 3A1 1 0 0012 16a1 1 0 00.72-.34l7-8a1 1 0 00-1.5-1.32L12 13.54z"
  }), /*#__PURE__*/node_modules_react.createElement("path", {
    d: "M21 11a1 1 0 00-1 1 8 8 0 01-8 8A8 8 0 016.33 6.36 7.93 7.93 0 0112 4a8.79 8.79 0 011.9.22 1 1 0 10.47-1.94A10.54 10.54 0 0012 2a10 10 0 00-7 17.09A9.93 9.93 0 0012 22a10 10 0 0010-10 1 1 0 00-1-1z"
  })))));
}

/* harmony default export */ var checkmark_circle_outline = (SvgCheckmarkCircleOutline);
;// CONCATENATED MODULE: ./components/Guestbook/person-outline.svg
var person_outline_g;

function person_outline_extends() { person_outline_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return person_outline_extends.apply(this, arguments); }



function SvgPersonOutline(props) {
  return /*#__PURE__*/node_modules_react.createElement("svg", person_outline_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), person_outline_g || (person_outline_g = /*#__PURE__*/node_modules_react.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/node_modules_react.createElement("g", {
    "data-name": "person"
  }, /*#__PURE__*/node_modules_react.createElement("path", {
    d: "M12 11a4 4 0 10-4-4 4 4 0 004 4zm0-6a2 2 0 11-2 2 2 2 0 012-2zM12 13a7 7 0 00-7 7 1 1 0 002 0 5 5 0 0110 0 1 1 0 002 0 7 7 0 00-7-7z"
  })))));
}

/* harmony default export */ var person_outline = (SvgPersonOutline);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/canvas-confetti/dist/confetti.module.mjs
var confetti_module = __webpack_require__(9883);
;// CONCATENATED MODULE: ./lib/utils/confetti.ts
// https://www.kirilv.com/canvas-confetti/#realistic

const count = 200;
const defaults = {
    origin: {
        y: 0.7
    }
};
function fire(particleRatio, opts) {
    (0,confetti_module/* default */.Z)(Object.assign({}, defaults, opts, {
        particleCount: Math.floor(count * particleRatio)
    }));
}
function fireConfetti() {
    fire(0.25, {
        spread: 26,
        startVelocity: 55
    });
    fire(0.2, {
        spread: 60
    });
    fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 0.8
    });
    fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.2
    });
    fire(0.1, {
        spread: 120,
        startVelocity: 45
    });
}

;// CONCATENATED MODULE: ./lib/types/form.ts
var FormState;
(function(FormState) {
    FormState[FormState["INITIAL"] = 0] = "INITIAL";
    FormState[FormState["LOADING"] = 1] = "LOADING";
    FormState[FormState["ERROR"] = 2] = "ERROR";
    FormState[FormState["SUCCESS"] = 3] = "SUCCESS";
})(FormState || (FormState = {}));

;// CONCATENATED MODULE: ./components/Skills/Badge.tsx












function Badge(param) {
    let { skill , user , currentUserId  } = param;
    var ref;
    const [state, setState] = (0,node_modules_react.useState)(FormState.INITIAL);
    const { mutate  } = (0,dist/* useSWRConfig */.kY)();
    async function onEndorse(skillId) {
        setState(FormState.LOADING);
        const res = await fetch("/api/endorsement", {
            body: JSON.stringify({
                skillId
            }),
            headers: {
                "Content-Type": "application/json"
            },
            method: "POST"
        });
        const { error  } = await res.json();
        if (error) {
            setState(FormState.ERROR);
            return;
        }
        mutate("/api/skill-category");
        setState(FormState.SUCCESS);
        fireConfetti();
    }
    const isUserEndorsed = skill === null || skill === void 0 ? void 0 : (ref = skill.users) === null || ref === void 0 ? void 0 : ref.find((u)=>u.id === currentUserId);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center text-base font-semibold",
                children: [
                    state === FormState.LOADING ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center w-8 h-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner, {})
                    }) : isUserEndorsed ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "font-semibold disabled:hover:cursor-not-allowed text-success-700 dark:text-success-400",
                        title: "You already endorsed this skill!",
                        disabled: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkmark_circle_outline, {
                            className: "inline w-8 h-8 fill-current "
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "font-semibold disabled:hover:cursor-not-allowed text-primary-600 dark:text-primary-400 hover:text-gray-700 dark:hover:text-gray-300 disabled:text-gray-700 dark:disabled:text-gray-300 ",
                        disabled: !Boolean(user),
                        title: !Boolean(user) ? "Please login first." : "Endorse this skill!",
                        onClick: ()=>onEndorse(skill.id),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(plus_square_outline, {
                            className: "inline w-8 h-8 fill-current "
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-2",
                        children: skill.name
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center gap-1 flex-wrap",
                children: skill.users.map((user)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        title: user.name,
                        className: "w-8 h-8",
                        children: user.image ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: user.image,
                            alt: user.name,
                            width: 32,
                            height: 32,
                            className: "rounded-full",
                            style: {
                                margin: "0"
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(person_outline, {
                            className: "w-8 h-8 p-0.5 rounded-full fill-current text-primary-600 dark:text-primary-400 border-2 border-solid border-primary-600 dark:border-primary-400"
                        })
                    }, user.id))
            }),
            skill.users.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-sm text-gray-600 dark:text-gray-400",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        className: "text-black dark:text-white",
                        children: skill.users.length
                    }),
                    " ",
                    "".concat(skill.name, " endorsement").concat(skill.users.length > 1 ? "s" : "", " from:"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mx-2",
                        children: skill.users.map((u)=>u.name).join(", ")
                    })
                ]
            }),
            state === FormState.ERROR && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage, {
                children: "An unexpected error occurred."
            }),
            state === FormState.SUCCESS && /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessMessage, {
                children: "Thank you for your endorsement!"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Skills/index.tsx






function Skills(param) {
    let { fallbackData  } = param;
    const { data: session  } = (0,react.useSession)();
    const { data: categories , error  } = (0,dist/* default */.ZP)("/api/skill-category", fetcher/* default */.Z, {
        fallbackData
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: categories && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mb-10",
            children: [
                error && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage, {
                    children: "An unexpected error occurred. The entries are not available for now. Please try again later"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-10 space-y-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-2xl font-bold leading-8 tracking-tight",
                            children: "Skills"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "space-y-8 divide-y divide-gray-200 dark:divide-gray-800",
                            children: categories.map((category)=>{
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            children: category.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "grid grid-cols-1 sm:grid-cols-2 grid-flow-row auto-rows-auto gap-2",
                                            children: category === null || category === void 0 ? void 0 : (ref = category.skills) === null || ref === void 0 ? void 0 : ref.map((skill)=>{
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Badge, {
                                                    skill: skill,
                                                    user: session === null || session === void 0 ? void 0 : session.user,
                                                    currentUserId: session === null || session === void 0 ? void 0 : session.id
                                                }, skill.id);
                                            })
                                        })
                                    ]
                                }, category.name);
                            })
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/CustomLink.tsx
var CustomLink = __webpack_require__(7896);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 32 modules
var format = __webpack_require__(8582);
;// CONCATENATED MODULE: ./components/Guestbook/GuestbookEntry.tsx







function GuestbookEntry(param) {
    let { entry , currentUserId  } = param;
    const { user , body , updated_at  } = entry;
    const [isDeleting, setIsDeleting] = (0,node_modules_react.useState)(false);
    const { mutate  } = (0,dist/* useSWRConfig */.kY)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isDeleting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col space-y-2 not-prose",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-gray-700 max-w-none dark:text-gray-300",
                    children: body
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center space-x-3",
                    children: [
                        user.image ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: user.image,
                            alt: user.name,
                            width: 20,
                            height: 20,
                            className: "rounded-full"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(person_outline, {
                            className: "w-5 h-5 rounded-full fill-current text-primary-600 dark:text-primary-400"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-sm text-gray-500",
                            children: entry.user.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: " text-gray-300 dark:text-gray-700",
                            children: "/"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-sm text-gray-300 dark:text-gray-700",
                            children: (0,format/* default */.Z)(new Date(updated_at), "d MMM yyyy 'at' h:mm bb")
                        }),
                        currentUserId === user.id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-gray-300 dark:text-gray-700",
                                    children: "/"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "text-sm text-danger-600 dark:text-danger-400",
                                    onClick: async (e)=>{
                                        e.preventDefault();
                                        setIsDeleting(true);
                                        await fetch("/api/guestbook/".concat(entry.id), {
                                            method: "DELETE"
                                        });
                                        mutate("/api/guestbook");
                                    },
                                    children: "Delete"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/Guestbook/index.tsx











function Guestbook(param) {
    let { fallbackData  } = param;
    const [form, setForm] = (0,node_modules_react.useState)(FormState.INITIAL);
    const inputEl = (0,node_modules_react.useRef)(null);
    const { data: session  } = (0,react.useSession)();
    const { error: entriesError , data: entries  } = (0,dist/* default */.ZP)("/api/guestbook", fetcher/* default */.Z, {
        fallbackData
    });
    const { mutate  } = (0,dist/* useSWRConfig */.kY)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-4 space-y-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "mt-4 text-2xl font-bold leading-8 tracking-tight",
                children: "Guestbook"
            }),
            Boolean(session === null || session === void 0 ? void 0 : session.user) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: "w-full my-4 flex flex-col items-center gap-4",
                        onSubmit: async (e)=>{
                            var ref;
                            e.preventDefault();
                            setForm(FormState.LOADING);
                            const res = await fetch("/api/guestbook", {
                                body: JSON.stringify({
                                    body: (ref = inputEl.current) === null || ref === void 0 ? void 0 : ref.value
                                }),
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                method: "POST"
                            });
                            const { error  } = await res.json();
                            if (error) {
                                setForm(FormState.ERROR);
                                return;
                            }
                            if (inputEl.current) inputEl.current.value = "";
                            mutate("/api/guestbook");
                            setForm(FormState.SUCCESS);
                            fireConfetti();
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                ref: inputEl,
                                "aria-label": "Your message",
                                placeholder: "Your message...",
                                required: true,
                                style: {
                                    resize: "none"
                                },
                                className: "px-4 py-2 focus:ring-primary-500 focus:border-primary-500 block w-full border-gray-300 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "px-4 py-2 flex items-center justify-center my-4 font-semibold text-lg text-white bg-primary-400 dark:bg-primary-600 hover:bg-primary-500 dark:hover:bg-primary-500 rounded self-end",
                                type: "submit",
                                children: form === FormState.LOADING ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner, {}) : "Send"
                            })
                        ]
                    }),
                    form === FormState.ERROR && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage, {
                        children: "An error occurred."
                    }),
                    form === FormState.SUCCESS && /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessMessage, {
                        children: "Awesome! Thank you for signing my guestbook."
                    })
                ]
            }),
            entriesError && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage, {
                children: "An unexpected error occurred. The entries are not available for now. Please try again later"
            }),
            entries ? entries.map((entry)=>{
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(GuestbookEntry, {
                    entry: entry,
                    currentUserId: session === null || session === void 0 ? void 0 : session.id
                }, entry.id);
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner, {})
        ]
    });
}

;// CONCATENATED MODULE: ./components/Metric/PageView.tsx





function PageViews() {
    const { data , error  } = (0,dist/* default */.ZP)("/api/analytics", fetcher/* default */.Z);
    if (error) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage, {
        children: "An error occurred when trying to load pageviews."
    });
    return (data === null || data === void 0 ? void 0 : data.pageViews) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "text-sm text-gray-600 dark:text-gray-400",
        children: [
            "All views: ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "font-semibold",
                children: data.pageViews
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner, {});
}

;// CONCATENATED MODULE: ./components/LoginView.tsx



function LoginView(param) {
    let { message  } = param;
    const { data: session  } = (0,react.useSession)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: !!(session === null || session === void 0 ? void 0 : session.user) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "text-lg text-gray-500 dark:text-gray-400 xl:text-xl",
            children: [
                "Logged in as ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                    children: [
                        session.user.name,
                        "."
                    ]
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                    className: "font-semibold",
                    href: "/api/auth/signout",
                    onClick: async (e)=>{
                        e.preventDefault();
                        await (0,react.signOut)();
                    },
                    children: "Log out"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mb-10 border-2 border-gray-400 dark:border-gray-600 rounded-md p-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-2xl font-bold leading-8 tracking-tight",
                    children: message
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "px-4 py-2 flex items-center justify-center my-4 font-semibold text-lg text-white bg-primary-400 dark:bg-primary-600 hover:bg-primary-500 dark:hover:bg-primary-500 rounded",
                    onClick: ()=>(0,react.signIn)(),
                    children: "Login"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-lg text-gray-500 dark:text-gray-400 xl:text-xl",
                    children: "Your information is only used to display your name and profile picture."
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./pages/endorsements.tsx









var __N_SSP = true;
function EndorsementsPage(param) {
    let { skillsByCategory , entries  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* PageSEO */.TQ, {
                title: "Endorsements – ".concat((siteMetadata_default()).author),
                description: "THVu's Endorsements"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-start justify-center max-w-2xl pt-6 pb-8 space-y-2 md:space-y-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
                        children: "Endorsements"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "prose dark:prose-dark",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-lg leading-7 text-gray-500 dark:text-gray-400 xl:text-xl",
                            children: "Since you're here, I invite you to give me endorsement(s) based on the experience you had with me in tech. You could also leave a comment ✍️ below."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-16 prose dark:prose-dark",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginView, {
                        message: "Login to give endorsements."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skills, {
                        fallbackData: skillsByCategory
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Guestbook, {
                        fallbackData: entries
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-sm text-gray-600 dark:text-gray-400 prose dark:prose-dark",
                        children: [
                            "This page is inspired by",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                href: "https://leerob.io/guestbook",
                                children: "Lee Robinson's guestbook."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageViews, {})
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,535,774,888,179], function() { return __webpack_exec__(4197); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);